<template>
    <div class="page-wrapper login-page">
        <Header/>
        <div class="wrapper">
            <div class="login-screen">
                <div class="eclipse">
                    <div class="vcenter-container">
                        <div class="vcenter"><img src="../image/eclipse.png"></div>
                    </div>
                </div>
                <div class="container">
                    <div class="content-block">
                        <div>
                            <div>
                                <div class="login-form">
                                    <div class="title">
                                        Регистрация
                                    </div>

                                    <div v-show="registerStatus == registerStatuses.newReg">
                                        <div class="soc-links">
                                            <span class="soc facebook" @click="facebookLogin"><img src="@/image/facebook.svg" alt="Facebook"></span>
                                            <span class="soc google" @click="googleLogin"><img src="@/image/google-plus.svg" alt="Google+"></span>
                                            <div class="text">или</div>
                                        </div>
                                        <div class="form dark-bg-form">
                                            <fieldset>
                                                <div class="gradient-border">
                                                    <div class="left"></div>
                                                    <div class="right"></div>
                                                    <input v-model.trim="user.name"
                                                           name="username"
                                                           ref="username"
                                                           type="text"
                                                           autocomplete="off"
                                                           required
                                                    >
                                                    <label>Ваше имя *</label>
                                                </div>
                                            </fieldset>
                                            <fieldset>
                                                <div class="gradient-border">
                                                    <div class="left"></div>
                                                    <div class="right"></div>
                                                    <input v-model.trim="user.email"
                                                           name="email"
                                                           type="text"
                                                           autocomplete="off"
                                                           required
                                                           v-validate="'required|email'"
                                                    >
                                                    <label>Email *</label>
                                                    <span v-show="errors.has('email')">{{ errors.first('email') }}</span>
                                                </div>
                                            </fieldset>
                                            <fieldset>
                                                <div class="gradient-border">
                                                    <div class="left"></div>
                                                    <div class="right"></div>
                                                    <date-picker
                                                            v-model="user.birthday"
                                                            format="DD.MM.YYYY"
                                                            lang="ru"
                                                            v-mask="'##.##.####'"
                                                            placeholder="дд.мм.гггг"
                                                            value-type="date"
                                                            :input-attr="{ id: 'datePicker', required: 'true' }"
                                                            :clearable="false"
                                                            :first-day-of-week="1">
                                                        <template slot="calendar-icon">&nbsp;</template>
                                                    </date-picker>
                                                </div>
                                            </fieldset>
                                            <fieldset>
                                                <div class="gradient-border">
                                                    <div class="left"></div>
                                                    <div class="right"></div>
                                                    <date-picker
                                                            v-model="user.birthtime"
                                                            type="time"
                                                            format="HH:mm"
                                                            lang="ru"
                                                            v-mask="'##:##'"
                                                            placeholder="чч:мм"
                                                            value-type="format"
                                                            :minute-step="1"
                                                            :input-attr="{ id: 'timePicker', required: 'true' }"
                                                            :clearable="false">
                                                        <template slot="calendar-icon">&nbsp;</template>
                                                    </date-picker>
                                                </div>
                                            </fieldset>
                                            <fieldset>
                                                <div class="gradient-border">
                                                    <div class="left"></div>
                                                    <div class="right"></div>
                                                    <city-picker
                                                            v-model="user.birthAddress"
                                                            :forward-value="true"/>
                                                </div>
                                            </fieldset>
                                            <div class="agree">
                                                <label><input v-model="checkedAgree"
                                                              type="checkbox" name=""> Я согласен на
                                                    <router-link :to="{name: 'PrivacyPolicy'}" target="_blank">обработку
                                                        персональных данных</router-link>
                                                    и с
                                                    <router-link :to="{name: 'TermsOfUse'}" target="_blank">пользовательским
                                                        соглашением</router-link>
                                                </label>
                                            </div>
                                            <div class="center">
                                                <button :disabled="isBlocked"
                                                        type="button"
                                                        class="button white-button"
                                                        @click="register"
                                                >Зарегистрироваться
                                                </button>
                                            </div>
                                        </div>
                                        <div class="login-dop-links">
                                            <div class="string">
                                                <router-link to="/login"><a class="login-form-link">Войти</a>
                                                </router-link>
                                            </div>
                                        </div>
                                        <div class="dop-info-text">
                                            Авторизуясь с помощью соц. сетей, вы соглашаетесь с
                                            <router-link to="/processing-agree"><a target="_blank">условиями обработки
                                                персональных данных</a></router-link>
                                            и с
                                            <router-link to="/user-offer"><a target="_blank">пользовательским
                                                соглашением</a></router-link>
                                            .
                                        </div>
                                    </div>

                                    <div class="successful-registration" v-show="registerStatus == registerStatuses.success">
                                        <div class="text successful-text">
                                            <div>Вы были успешно зарегистрированы!</div>
                                            <div>
                                                Пароль к вашей учётной записи был отправлен на почтовый адрес <a :href="`mailto: ${user.email}`">{{ user.email }}</a>.
                                            </div>
                                        </div>
                                        <div class="success-check">
                                            <img src="@/image/success-check.png">
                                        </div>
                                    </div>

                                    <div class="error-soc-email-busy" v-show="registerStatus == registerStatuses.emailTaken">
                                        <div class="text error-registration-text">
                                            <div>Этот email уже зарегистрирован.</div>
                                            <div>
                                                Если Вы забыли пароль, пожалуйста, воспользуйтесь <router-link :to="{name: 'ForgotPassword'}">формой восстановления пароля</router-link>.
                                            </div>
                                        </div>
                                        <div class="error-registration-icon">
                                            <img src="@/image/icon-error.png">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="login-screen-bg bg-animation"></div>
            </div>
        </div>
        <Footer :no-footer="true"/>
    </div>
</template>

<script>
    import constants from '@/constants';
    import nativeDom from '@/native-dom.js';
    import utils from '@/utils';
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import CityPicker from '@/components/CityPicker';
    import {Validator} from 'vee-validate';
    import {mask} from 'vue-the-mask';
    import DatePicker from 'vue2-datepicker';

    const registerStatusesInternal = Object.freeze({
        newReg: 1,
        success: 2,
        emailTaken: 3
    });

    export default {
        name: "Registration",
        components: {
            Header, Footer, CityPicker, DatePicker
        },

        directives: {mask},

        data() {
            return {
                user: {
                    name: '',
                    email: '',
                    birthday: '',
                    birthtime: '',
                    birthAddress: null
                },
                registerStatuses: registerStatusesInternal,
                checkedAgree: false,
                registerStatus: registerStatusesInternal.newReg
            }
        },

        mounted() {
            console.log(this.registerStatuses);

            Validator.localize('en', constants.dictionary);

            nativeDom.initLabelForDatePicker();
            nativeDom.initLabelForTimePicker();

            this.$refs.username.focus();
        },

        computed: {
            isBlocked() {
                return !(Object.keys(this.fields).some(key => this.fields[key].valid)
                        && this.user.name !== '' && this.checkedAgree)
            },
        },

        methods: {
            googleLogin() {
                window.location.href = constants.GOOGLE_AUTH_URL;
            },

            facebookLogin() {
                window.location.href = constants.FACEBOOK_AUTH_URL;
            },

            async register() {
                if (!!this.isBlocked)
                    return;

                let birthday = utils.getUnixTimeOfBirthdateAndTime(this.user.birthday, this.user.birthtime);

                let userReg = {
                    name: this.user.name,
                    username: this.user.name,
                    email: this.user.email,
                    birthday: birthday,
                    birthAddress: this.user.birthAddress
                };

                let success = await this.$store.dispatch('registration', userReg);
                if (!!success) {
                    this.registerStatus = this.registerStatuses.success;
                    setTimeout(() => {
                        this.$router.push({name: 'Login'});
                    }, 2500);
                } else {
                    this.registerStatus = this.registerStatuses.emailTaken;
                }
            }
        }
    }
</script>
